import type { Release } from '../releases';

export default {
  id: '2026-11-03-procurement-object-status',
  at: '2026-11-04T12:24:00Z',
  title: 'Заявка на закуп: объект, служебный статус и новые фильтры сводки',
  modules: ['procurement'],
  items: [
    'В заявке на закуп можно указать объект проекта. Сводка руководителя закупок фильтруется по объекту и по подразделению инициатора.',
    'На доске и в карточке заявки рядом с этапом виден служебный статус: поставщик выбран, договор на согласовании, договор согласован — на подписании, договор подписан, включено в реестр.',
    'Поиск заявок находит их по названию или шифру объекта и по номеру запроса КП. Запрос КП теперь нумеруется с годом: ЗКП-2026-012.',
  ],
  why: 'Руководителю закупок нужно видеть, где стоит каждая заявка и для какого объекта она, не открывая карточки; номера и статусы — те же, что в регламенте.',
  link: '/procurement',
} satisfies Release;
